//this file contains the common conatiner styles like ColumnContainer, RowContainer etc

import { Link } from "react-router-dom";
import styled from "styled-components";

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  &.shadow {
    box-shadow: rgb(0 0 0 / 16%) 0px 1px 4px;
  }
  &.booking-container {
    height: calc(100vh - 200px);
    overflow: auto;
  }
  &.container {
    justify-content: center;
    max-width: 1200px;
    width: 100%;
    margin: auto;
  }
  &.full {
    max-width: 100%;
  }
  &.login {
    align-items: center;
    padding: 0;
  }

  &.left {
    justify-content: left;
  }
  h1 {
    margin: 50px 10px;
  }
  @media screen and (max-width: 768px) {
    flex-direction: column;
    &.booking-container {
      height: auto;
      overflow: initial;
    }
    &.login {
      align-items: center;
      padding: 10px 10px;
    }
    h1 {
      margin: 15px 15px 10px;
      font-size: 20px;
      text-align: center;
    }
    &.header {
      flex-direction: row;
    }
  }
`;
export const RowContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  margin-right: 15px;
  margin-bottom: auto;
  && {
    .payment & {
      margin-right: 0px;
    }
    .no-shadow & {
      margin-right: 0px;
    }
  }
  .map-container {
    width: 100%;
    height: 100vh;
    border-radius: 10px 10px 0 0;
    border: 1px solid #bdbdbd !important;
  }

  &.center h2 {
    justify-content: center;
    text-align: center;
    margin: 3em 0em 1em;
  }
  &.features {
    background-color: white;
    padding-bottom: 50px;
  }
  &.white {
    background-color: white;
    align-items: center;
    justify-content: center;
    display: flex;
    padding-bottom: 70px;
    flex-basis: auto;
    h1 {
      max-width: 80%;
      font-size: 25px;
    }
    a {
      background: rgb(19, 129, 197);
      border-radius: 12px;
      color: white;
      transition: all 0.5s ease 0s;
      margin-top: 10px;
      max-width: 400px;
      padding: 15px 20px;
      min-width: 155px;
      border-color: black;
      border-style: solid;
      cursor: pointer;
      border-width: 0px;
      text-align: center;
      text-decoration: none;
    }
  }
  &.map {
    width: calc(100% - 500px);
    height: calc(100vh - 200px);
    margin-right: 0px;
    flex: auto;
  }
  &.booking {
    width: 500px;
    height: calc(100vh - 200px);
    overflow: auto;
    position: relative;
    flex: auto;
  }
  &.width60 {
    flex: 1 1 calc(100% - 400px);
  }
  &.width40 {
    flex: 1 1 440px;
    margin-right: 0px;
  }
  @media screen and (max-width: 768px) {
    max-width: 100%;
    padding: 10px;
    margin-right: 0px;
    .map-container {
      height: 400px;
      margin-bottom: 30px;
    }
    &.booking {
      height: auto;
      overflow: initial;
    }
    &.map {
      height: auto;
    }
    &.white {
      background-color: white;
      align-items: center;
      justify-content: center;
      display: flex;
      padding-bottom: 50px;
      flex-basis: auto;
      h1 {
        max-width: 80%;
        font-size: 17px;
      }
    }
    && {
      .no-shadow & {
        padding: 2px;
      }
    }
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: row;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: column;
  &.hide {
    display: none;
  }
`;

export const LinkButton = styled(Link)`
  margin: 5px;
  text-decoration: none;
  background-color: #1381c5;
  color: white;
  padding: 5px 15px;
  border-radius: 10px;
  align-items: center;
  display: flex;
  justify-content: center;
  &:first-child {
    margin-left: 0;
  }
  svg {
    margin-right: 10px;
    color: white;
  }
`;
export const Points = styled.div`
  width: 33%;
  text-align: center;
  padding: 40px;
  h4 {
    color: #006dbf;
  }
  p {
    color: #7f7f7f;
    font-size: 16px;
  }
  @media screen and (max-width: 768px) {
    width: calc(100% - 100px);
    margin: 10px;
    h4 {
      color: #006dbf;
      font-size: 22px;
    }
    p {
      color: #7f7f7f;
      font-size: 18px;
    }
  }
`;

export const SlidePopup = styled.div`
  position: absolute;
  left: 20px;
  right: 5px;
  top: auto;
  bottom: 0;
  background-color: white;
  min-height: 50%;
  box-shadow: rgb(0 0 0 / 16%) 0px 0px 2px 0px;
  border-radius: 10px 10px 0 0;
  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 10px 10px 0 0;
    cursor: pointer;
  }
  button {
    font-weight: bold;
    margin: auto;
    width: 100%;
    border-radius: 10px;
  }
`;
